export default __webpack_public_path__ + "svg/calendar/2027/2/abril.svg?8b5f363c";